import React from "react";
import PropTypes from "prop-types";
import FormFieldTwoColumns from "./Layouts/FormFieldTwoColumns";
import FormAsync from "./FormAsync";
import { ControllerProps } from "react-hook-form";

type Filter = { field: string; value: string | number | null | undefined; operator: "=" | "!=" | "in" | "like" };

function FormAsyncTC(props: {
  name: string;
  tKey: string;
  tDefault: string;
  async: {
    url: string;
    searchField: string;
    extraFilters: Filter | Filter[];
  };
  label?: any;
  rules?: ControllerProps["rules"];
  nullable?: boolean;
  multiple?: boolean;
  freeSolo?: boolean;
}) {
  return (
    <FormFieldTwoColumns {...props}>
      <FormAsync />
    </FormFieldTwoColumns>
  );
}

FormAsyncTC.defaultProps = {
  multiple: false,
  nullable: false,
  freeSolo: false,
};

FormAsyncTC.propTypes = {
  name: PropTypes.string.isRequired, // FormField props
  permissionKey: PropTypes.string, // FormField props
  gridSizes: PropTypes.object, // FormField props
  rules: PropTypes.object, // FormField props
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]), // FormField props

  async: PropTypes.object.isRequired,
  multiple: PropTypes.bool,
  freeSolo: PropTypes.bool,
};

export default FormAsyncTC;
